export { UserDetail as default } from './user-detail';
